import React, { useContext, useEffect, useState } from 'react';
import {
    Button,
    Col,
    Container,
    Form,
    Row,
    Spinner
} from 'react-bootstrap';

import AuthContext from '../../Context/authContext';
import { forgotPassword } from '../../Services/api';
import Notification, { useNotification } from 'src/Components/Notification';
import './style.scss';


const PasswordResetPage = () => {
    const [userEmail, setUserEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { setIsAdmin } = useContext(AuthContext);
    const { notifySuccess, notifyError, onClose, notification } = useNotification();

    useEffect(() => {
        setIsAdmin(true);
    }, [setIsAdmin]);

    const handleSubmit = async e => {
        setIsLoading(true);
        e.preventDefault();
        const email = userEmail.toLowerCase();
        const reset_resp = await forgotPassword({ email });

        if (reset_resp.status !== 200) {
            const errMsg = reset_resp.response.data.detail;
            notifyError({ message: errMsg });
        } else {
            notifySuccess({ message: reset_resp.data.message });
        }
        setIsLoading(false);
    };

    return (
        <>
            <Container className='sharedAuthStyles resetContainer'>
                <Notification id="password-reset-notif" onClose={onClose} {...notification} />
                <div className='header mb-5'>
                    <h4 className='text-secondary'>Password reset</h4>
                    <p className='text-muted'>
                        Enter your registered email address to receive instructions on how to reset your password
                    </p>
                </div>
                <Form onSubmit={handleSubmit}>
                    <Row className='mb-5'>
                        <Col>
                            <Form.Group controlId='formEmail'>
                                <Form.Control
                                    autoFocus
                                    className='formInput text-dark'
                                    type='text'
                                    placeholder='Email'
                                    value={userEmail}
                                    onChange={(e) => setUserEmail(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className='text-center'>
                        <Button
                            className='business submitButton mt-5'
                            type='submit'
                            disabled={!(userEmail.length > 0 ) || isLoading}
                        >
                            {isLoading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            Submit
                        </Button>
                    </div>
                </Form>
            </Container>
        </>
    )
};

export default PasswordResetPage;
